import Vue from 'vue';
import Vuex from 'vuex';
import app from "./modules/app";
import weather from "./modules/weather";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    weather,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
});
